import jobTitlesApi from '../../../Api/axios/job-titles-api';
import useTranslation from '../../../Hooks/useTranslation';

const useUpdate = ({ data, cancel, allJobTitles, setAllJobTitles }) => {
  const { t } = useTranslation();
  const handleClick = async () => {
    const status = !(data[3] === t('Generic.Active'));
    const id = data[4];
    try {
      await jobTitlesApi.patch(id, { status: status });
      const newAllJobTitles = allJobTitles.map(jobTitle => {
        if (jobTitle[4] === id) {
          const newJobTitle = [...jobTitle];
          newJobTitle[3] = status ? t('Generic.Active') : t('Generic.Inactive');
          return newJobTitle;
        }
        return jobTitle;
      });
      setAllJobTitles(newAllJobTitles);
    } catch (error) {
      console.error(error);
    } finally {
      cancel();
    }
  };

  return {
    handleClick,
  };
};

export default useUpdate;
